import { render, staticRenderFns } from "./DefaultVideoComponent.vue?vue&type=template&id=59bdb749&scoped=true&"
import script from "./DefaultVideoComponent.vue?vue&type=script&lang=js&"
export * from "./DefaultVideoComponent.vue?vue&type=script&lang=js&"
import style0 from "./DefaultVideoComponent.vue?vue&type=style&index=0&id=59bdb749&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdb749",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BEmbed, BContainer} from 'bootstrap-vue'
    installComponents(component, {BEmbed, BContainer})
    

export default component.exports